export const ImaginePayCardTokenBlock = (bm, category, label, type) => {
  bm.add(type, {
    label: `<i class="wb webconnect-card"></i><div>${label}</div>`,
    category: category,
    content: `
    <form onsubmit="return registerImaginePayCard(event)" 
      class="dc-form-default dc-form-bordered" 
      data-gjs-type="${type}" data-gjs="${type}" 
      id="credit-card-form" method="post"
      data-gjs-custom-name="${label}">
    <div class="col-12 col-md-12">
      <h4 class="title">Register Credit Card Information</h4>
    </div>
    <div class="form-container row mx-auto" draggable="false" data-gjs-copyable="false" data-gjs-selectable="true" data-gjs-custom-name="Form Container">
      <div class="alert alert-danger alert-message" style="display: none"></div>
      <div class="alert alert-success success-message" style="display: none"></div>
      <div class="form-group col-12 col-md-12">
        <label>Card Number*</label>
        <input name="card_number" id="card_number" type="text"
          placeholder="xxxx-xxxx-xxxx-xxxx" 
          class="form-control input--style" />
      </div>
      <div class="form-group col-6 col-md-6">
        <label>Card Expiry Month*</label>
        <select name="card_expiry_month" id="card_expiry_month" class="form-control input--style">
          <option> -Select Month- </option>
          <option value="01">Jan (01)</option>
          <option value="02">Feb (02)</option>
          <option value="03">Mar (03)</option>
          <option value="04">Apr (04)</option>
          <option value="05">May (05)</option>
          <option value="06">Jun (06)</option>
          <option value="07">Jul (07)</option>
          <option value="08">Aug (08)</option>
          <option value="08">Sep (09)</option>
          <option value="10">Oct (10)</option>
          <option value="11">Nov (11)</option>
          <option value="12">Dec (12)</option>
        </select>
      </div>
      <div class="form-group col-6 col-md-6">
        <label>Card Expiry Year*</label>
        <select name="card_expiry_year" id="card_expiry_year" class="form-control input--style">
          <option> -Select Year- </option>
        </select>
      </div>
      <div class="form-group col-12 col-md-12">
        <label>Card Holder Name</label>
        <input name="card_holder_name" id="card_holder_name" type="text" placeholder="Card Holder Name" class="form-control input--style" />
      </div>
      <div class="form-group col-12 col-md-12 p-t-10 no-border-bottom">
        <button type="submit" class="btn btn-primary">Register</button>
      </div>
    </div>
    </form>
    `,
  });
};
export default (dc, label, type, config) => {
  const defaultType = dc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  const { projectId, collections } = config;
  dc.addType(type, {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          icon: '<i class="wb webconnect-card"></i>',
          projectId,
          resizable: true,
          traits: [
            {
              type: 'webconnect-event',
              label: false,
              name: 'onsubmit',
            },
            ...defaultModel.prototype.defaults.traits,
          ],
          script: function () {
            const cardExpirySelect = document.getElementById('card_expiry_year');
            const currentYear = new Date().getFullYear();
            for (let i = 0; i <= 9; i++) {
              const opt = document.createElement('option');
              opt.value = currentYear + i;
              opt.innerHTML = currentYear + i;
              cardExpirySelect.appendChild(opt);
            }
            $('#credit-card-form').validate({
              rules: { card_number: { required: true, creditcard: true } },
            });
          },
        },
        async init() {},
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === type) {
            return {
              type: type,
            };
          }
        },
      },
    ),
    view: defaultView.extend({
      init({ model }) {},
    }),
  });
};
